import { getEnv } from '@luna/env';
import { getFeatureConfig } from '@luna/feature-config';

import { isAlexProxyActive } from './AlexProxyService';
import { isFeatureBranch } from './EnvironmentService';

export function isOpenIdConnectEnabled(): boolean {
    const { country } = getFeatureConfig((config) => config.base);
    if (isAlexProxyActive()) {
        return false;
    }

    if (isFeatureBranch(window.location.hostname) && country !== 'RS') {
        return false;
    }

    return !!getEnv().oidc;
}

export function isCsrfFeatureEnabled(): boolean {
    if (isOpenIdConnectEnabled()) {
        return false;
    }

    return !!getEnv()?.csrfToken;
}
